import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { blogData } from "./utils";

const BlogSingle = ({ blog }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const post = blog || blogData.find((b) => b.id === Number(id));

  if (!post) {
    return (
      <section style={styles.container}>
        <p style={styles.notFound}>Blog not found.</p>
        <button style={styles.backBtn} onClick={() => navigate("/blog")}>
          Go back to blog list
        </button>
      </section>
    );
  }

  return (
    <section style={styles.container}>
      <button style={styles.backBtn} onClick={() => navigate("/blog")}>
        ← Back to Blog List
      </button>

      <article style={styles.article}>
        <img src={post.image} alt={post.title} style={styles.image} />

        {/* Gradient Heading */}
        <h1 style={styles.title}>{post.title}</h1>

        <div style={styles.meta}>
          <span>{post.date}</span>
          <span> • {post.author}</span>
        </div>

        <p style={styles.content}>{post.content}</p>

        {post.sections?.map((sec, idx) => (
          <div key={idx} style={styles.section}>
            <h3 style={styles.sectionTitle}>{sec.heading}</h3>
            <p style={styles.sectionText}>{sec.body}</p>
          </div>
        ))}

        {/* Tags */}
        <div style={styles.tagsContainer}>
          {post.tags?.map((tag, i) => (
            <span key={i} style={styles.tag}>
              #{tag}
            </span>
          ))}
        </div>
      </article>
    </section>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "40px auto",
    padding: "0 20px",
    background:
      "radial-gradient(circle at top, rgba(0,0,0,0.03), transparent)",
  },

  notFound: {
    textAlign: "center",
    fontSize: "20px",
    marginBottom: "20px",
  },

  backBtn: {
    background: "#0055ff",
    border: "1px solid #e5e7eb",
    color: "#ffffff",
    padding: "8px 14px",
    borderRadius: 8,
    cursor: "pointer",
    marginBottom: 20,
  },

  article: {
    background: "#fff",
    borderRadius: 16,
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    padding: 28,
  },

  image: {
    width: "100%",
    borderRadius: 12,
    objectFit: "cover",
    maxHeight: 420,
    marginBottom: 24,
  },

  // 🎨 Gradient Heading
  title: {
    fontSize: "36px",
    fontWeight: 800,
    marginBottom: 10,
    lineHeight: "1.2",
    background: "linear-gradient(90deg, #ef4444, #f59e0b)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  meta: {
    color: "#6b7280",
    marginBottom: 20,
    fontSize: "14px",
  },

  content: {
    fontSize: "18px",
    lineHeight: 1.8,
    color: "#374151",
    marginBottom: 20,
  },

  section: {
    marginBottom: 20,
    padding: "16px",
    borderRadius: "10px",
    background: "#f9fafb",
  },

  sectionTitle: {
    fontSize: "22px",
    marginBottom: 8,
    color: "#111827",
  },

  sectionText: {
    fontSize: "16px",
    color: "#4b5563",
    lineHeight: 1.6,
  },

  tagsContainer: {
    marginTop: 20,
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  },

  tag: {
    background: "#fef2f2",
    color: "#ef4444",
    padding: "6px 10px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
};

export default BlogSingle;